// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/webpack-hot-middleware/client.js?path=/__webpack_hmr&timeout=20000");
var __webpack_exports__ = __webpack_require__("./src/index.ts");
